var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Inject } from 'vue-property-decorator';
import bridge from './utils/bridge';
import render from './utils/render';
import { containerSymbol } from './utils/symbol';
let MarpSlide = class MarpSlide extends Vue {
    render(createElement) {
        const h = bridge(createElement);
        return (h("div", { class: this.$_container }, render(createElement, this.slide)));
    }
};
__decorate([
    Prop({ type: Array, required: true })
], MarpSlide.prototype, "slide", void 0);
__decorate([
    Inject(containerSymbol)
], MarpSlide.prototype, "$_container", void 0);
MarpSlide = __decorate([
    Component
], MarpSlide);
export { MarpSlide };
export default MarpSlide;
